module.exports = __webpack_public_path__ + "assets/images/img/Image2.72277409cf2da761b861b9c4e82be46a.jpg";